import React from 'react';
import Icon from 'components/Icon';

export default icon => ({shade}) => (
  <Icon size={Icon.SIZES.MICRO} icon={icon} shade={shade} />
);
